import * as mutations from "../types";
import Vue from "vue";
import _ from "lodash/array";
import dayjs from "dayjs";
import { EventBus } from "@/tools/event-bus";

export default {
  [mutations.APPLY_FILTERS](state, filters) {
    state.eventFilters = filters;
  },
  [mutations.REMOVE_EVENT_FILTER](state, filterName) {
    Vue.delete(state.eventFilters, filterName);
  },
  [mutations.APPLY_AGENDA_FILTERS](state, filters) {
    state.eventAgendaFilters = filters;
  },
  [mutations.REMOVE_AGENDA_EVENT_FILTER](state, filter) {
    let cloneFilters = { ...state.eventAgendaFilters };
    delete cloneFilters[filter];

    state.eventAgendaFilters = cloneFilters;
  },
  [mutations.ADD_EVENT](state, newEvent) {
    if (Object.prototype.hasOwnProperty.call(state.items, newEvent.id)) {
      return;
    }

    let timeSlots = newEvent["time_slots"];
    delete newEvent["time_slots"];
    Vue.set(state.items, newEvent.id, newEvent);
    state.items[newEvent.id] = newEvent;

    // Pas de créneau horaire, on met l'evt dans le puit
    if (!timeSlots.length) {
      if (!state.toBePlannedEvents.includes(newEvent.id)) {
        state.toBePlannedEvents.push(newEvent.id);
      }

      return;
    }

    timeSlots.forEach((timeSlot) => {
      timeSlot.eventId = newEvent.id;
      timeSlot.display = { position: "full", relatedTs: [] };

      let i = 0;
      while (
        i < state.timeSlots.length &&
        dayjs(state.timeSlots[i].date + "T" + state.timeSlots[i].time).isBefore(
          timeSlot.date + "T" + timeSlot.time
        )
      ) {
        i++;
      }

      state.timeSlots.splice(i, 0, timeSlot);
    });
  },
  [mutations.BLOCK_TIMESLOT_EDITION](state, value) {
    state.blockTimeSlotEdition = value;
  },
  [mutations.PLAN_EVENT](state, plannedEventId) {
    state.items[plannedEventId].state = "planned";
    state.toBePlannedEvents = _.without(
      state.toBePlannedEvents,
      plannedEventId
    );
  },
  [mutations.CANCEL_PLAN_EVENT](state) {
    // state.timeSlots = state.timeSlots.filter(
    //   (timeSlot) => timeSlot.eventId !== state.selectedTimeSlot.eventId
    // );
    state.timeSlots = state.timeSlots.filter(
      (timeSlot) => timeSlot.eventId !== state.selectedCalendarEvent?.event?.id
    );
  },
  [mutations.UNPLAN_EVENT](state, eventId) {
    let event = state.items[eventId];

    state.timeSlots = state.timeSlots.filter(
      (timeSlot) => timeSlot.eventId !== eventId
    );
    let index = 0;

    // locate index according deadline date order
    if ("deadline" in event) {
      state.toBePlannedEvents.some((tbpEventId) => {
        let tobePlannedEvent = state.items[tbpEventId];
        if (
          !("deadline" in tobePlannedEvent) ||
          dayjs(tobePlannedEvent.deadline).isBefore(event.deadline)
        ) {
          index++;
          return false;
        }
        return true;
      });
    }

    if ("parentId" in event) {
      delete state.items[eventId];
    } else {
      state.toBePlannedEvents.splice(index, 0, eventId);
      event.state = "to_be_planned";
    }
  },
  [mutations.CONFIRM_SELECTED_EVENT](state, confirmEvent) {
    state.items[confirmEvent.id] = confirmEvent;
  },
  [mutations.DEFINE_SIMULTANEOUS_TIME_SLOT](state, { ts1, ts2 }) {
    if (!ts1.display.relatedTs.includes(ts2.id)) {
      ts1.display.relatedTs.push(ts2.id);
    }
    if (!ts2.display.relatedTs.includes(ts1.id)) {
      let id = ts1.id ? ts1.id : "unknown";
      ts2.display.relatedTs.push(id);
    }

    if (ts2.duration > ts1.duration) {
      ts2.display.position = "ts-left";
      ts1.display.position = "ts-right";
    } else {
      ts2.display.position = "ts-right";
      ts1.display.position = "ts-left";
    }
  },
  [mutations.REMOVE_SIMULTANEOUS_TIME_SLOT](
    state,
    { removedTimeSlot, simultaneousTimeSlot }
  ) {
    simultaneousTimeSlot.display.relatedTs = _.without(
      simultaneousTimeSlot.display.relatedTs,
      removedTimeSlot.id
    );
    if (simultaneousTimeSlot.display.relatedTs.length === 0) {
      simultaneousTimeSlot.display.position = "full";
    }
  },
  [mutations.UPDATE_EVENT](state, updatedEvent) {
    let city = updatedEvent.city;

    if (city && city.name) {
      city = city.name;
    }

    if (Object.prototype.hasOwnProperty.call(state.items, updatedEvent.id)) {
      if (city) {
        state.items[updatedEvent.id] = { ...updatedEvent, city };
      } else {
        state.items[updatedEvent.id] = updatedEvent;
      }
    }
  },
  [mutations.UPDATE_EVENT_PICKED_DURATION](state, eventId) {
    let timeSlots = state.timeSlots.filter((ts) => ts.eventId === eventId);
    let sumDuration = 0;
    timeSlots.forEach((element) => (sumDuration += element.duration));
    state.items[eventId].duration = sumDuration;
  },
  [mutations.UPDATE_TIME_SLOT](state, updatedTimeSlot) {
    const index = state.timeSlots.findIndex(
      (ts) => ts.id === updatedTimeSlot.id
    );
    if (index !== -1) {
      state.timeSlots[index].time = updatedTimeSlot.time;
      state.timeSlots[index].duration = updatedTimeSlot.duration;
      state.timeSlots[index].break_duration = updatedTimeSlot.break_duration;
      state.timeSlots[index].date = updatedTimeSlot.date;
    }
  },
  [mutations.DEFINE_TIME_SLOT_ID](state, { timeSlot, id }) {
    timeSlot.id = id;

    state.timeSlots
      .filter((timeSlot) => timeSlot.display.relatedTs.includes("unknown"))
      .forEach((timeSlot) => {
        timeSlot.display.relatedTs = timeSlot.display.relatedTs.map(
          (relatedTsId) => (relatedTsId === "unknown" ? id : relatedTsId)
        );
      });
  },
  [mutations.LOAD_CALENDAR_OWNERS](state, calendarOwners) {
    state.calendarOwners = calendarOwners;
  },
  [mutations.LOAD_CALENDAR_OWNER](state, newCalendarOwner) {
    const existingCalendarOwnerIndex = state.calendarOwners.findIndex(
      (calendarOwner) => {
        return calendarOwner.id === newCalendarOwner.id;
      }
    );

    if (existingCalendarOwnerIndex === -1) {
      state.calendarOwners.push(newCalendarOwner);
    } else {
      Vue.set(
        state.calendarOwners,
        existingCalendarOwnerIndex,
        newCalendarOwner
      );
    }
  },
  [mutations.LOAD_EVENT_TYPE](state, eventTypes) {
    state.eventTypes = {};

    eventTypes.forEach((element) => {
      state.eventTypes[element.name] = element;
    });
  },
  [mutations.LOAD_EVENT_TYPE_GROUP](state, eventTypesGroup) {
    state.eventTypesGroup = eventTypesGroup;
  },
  [mutations.FETCH_CREDIT](state, credits) {
    state.credits = [];
    state.credits = credits;
  },
  [mutations.FETCH_REST_WORK_TIME](state, restWorkTime) {
    state.restWorkTime = restWorkTime;
  },
  // Remove event from store
  [mutations.ARCHIVE_EVENT](state, eventId) {
    if (Object.prototype.hasOwnProperty.call(state.items, eventId)) {
      if (state.items[eventId].state === "to_be_planned") {
        state.toBePlannedEvents = _.without(state.toBePlannedEvents, eventId);
      } else {
        state.timeSlots = state.timeSlots.filter(
          (timeSlot) => timeSlot.eventId !== eventId
        );
      }

      delete state.items[eventId];
    }
  },

  [mutations.CLEAR_TO_BE_PLANNED_EVENT](state) {
    state.toBePlannedEvents = [];
  },

  [mutations.CREATE_EVENT_TIME_SLOT](state, eventId) {
    // let timeSlot = {
    //   date: undefined,
    //   time: undefined,
    //   eventId: eventId,
    //   display: { position: "full", relatedTs: [] },
    //   duration: state.items[eventId].duration,
    // };
    //
    // state.timeSlots.push(timeSlot);
    // state.selectedTimeSlot = timeSlot;

    if (state.items[eventId]) {
      const duration = state.items[eventId].duration ?? 0;

      const timeSlot = {
        date: undefined,
        time: undefined,
        eventId: eventId,
        display: { position: "full", relatedTs: [] },
        duration,
      };

      state.timeSlots.push(timeSlot);

      const start = dayjs();
      const end = start.add(duration, "minute");

      state.selectedCalendarEvent = {
        start: start.toDate().getTime(),
        end: end.toDate().getTime(),
        dynamic: true,
        timed: true,
        event: state.items[eventId],
        timeSlot,
      };
    }
  },
  [mutations.CLEAR_PLAN_EVENT]: (state) => {
    let eventToClear = Object.keys(state.items);

    eventToClear.forEach((eventId) => {
      if (!state.toBePlannedEvents.includes(parseInt(eventId))) {
        Vue.delete(state.items, eventId);
      }
    });

    state.timeSlots = [];
  },
  [mutations.CLEAR_AGENDA_FILTER](state) {
    state.eventAgendaFilters = {};
  },
  [mutations.AUTH_SUCCESS]: (state, resp) => {
    state.security.token = resp.data["access_token"];
    localStorage.setItem("user-token", resp.data["access_token"]);
    state.hasLoadedOnce = true;
    state.security.refreshToken = resp.data["refresh_token"];
    localStorage.setItem("refresh-token", resp.data["refresh_token"]);
    state.security.expireAt = dayjs()
      .add(resp.data["expires_in"], "s")
      .format();
    localStorage.setItem("expire-at-token", state.security.expireAt);
  },
  [mutations.ALLOCATE_CREDIT]: (state) => {
    state.replaceSubtype = true;
  },
  [mutations.AUTH_ERROR]: (state) => {
    state.hasLoadedOnce = true;
  },
  [mutations.AUTH_LOGOUT]: (state) => {
    state.items = {};
    state.timeSlots = [];
    state.customer = { roles: [] };
    state.toBePlannedEvents = [];
    state.security.token = undefined;
    state.security.expireAt = undefined;
    state.security.refreshToken = undefined;
  },
  [mutations.AUTH_INIT]: (state, customerData) => {
    state.customer = customerData;
  },
  [mutations.AUTH_REMOVE_REFRESH]: (state) => {
    state.security.refreshToken = undefined;
  },
  [mutations.READ_NOTIFICATION]: (state, notification) => {
    state.notifications = _.without(state.notifications, notification);
  },
  [mutations.SET_DOMICILE]: (state, domicile) => {
    state.domicile = domicile;
  },
  [mutations.SET_EVENT_SEARCH]: (state, eventSearch) => {
    state.eventSearch = eventSearch;
  },
  [mutations.SET_LOADING]: (state, isLoading) => {
    state.loading = isLoading;
  },
  [mutations.SET_IMPERSONATE]: (state, impersonate) => {
    state.items = {};
    state.timeSlots = [];
    state.impersonate = impersonate;
    state.customer = { roles: [] };
    state.toBePlannedEvents = [];
  },
  [mutations.UNSET_IMPERSONATE]: (state) => {
    state.items = {};
    state.timeSlots = [];
    state.impersonate = undefined;
    state.customer = { roles: [] };
    state.toBePlannedEvents = [];
  },
  [mutations.SET_CALENDAR_OWNER]: (state, calendarOwner) => {
    state.calendarOwner = calendarOwner;
  },
  [mutations.LOAD_HOLIDAYS]: (state, { holidays, year }) => {
    state.loadedHolidayYears = Array.from(
      new Set(state.loadedHolidayYears.concat(+year))
    );
    state.holidays = Array.from(new Set(state.holidays.concat(holidays)));
  },
  [mutations.SET_SUPERVISION_FILTERS_ENABLED]: (
    state,
    supervisionFiltersEnabled
  ) => {
    state.supervisionFiltersEnabled = supervisionFiltersEnabled;
  },
  [mutations.FETCH_DEPARTMENTS]: (state, departments) => {
    state.departments = departments;
  },
  [mutations.FETCH_BUSINESS_GROUPS]: (state, businessGroups) => {
    state.businessGroups = businessGroups;
  },
  [mutations.FETCH_EVENT_RULES]: (state, eventRules) => {
    state.eventRules = eventRules;
  },
  [mutations.REMOVE_EVENT_RULE]: (state, eventId) => {
    const index = state.eventRules.indexOf(eventId);

    if (index !== -1) {
      state.eventRules.splice(index, 1);
    }
  },
  [mutations.SET_CALENDAR_DATE]: (state, value) => {
    state.calendarDate = value;
  },
  [mutations.SET_SELECTED_CALENDAR_EVENT]: (state, selectedCalendarEvent) => {
    state.selectedCalendarEvent = selectedCalendarEvent;

    if (
      selectedCalendarEvent !== null &&
      selectedCalendarEvent.timeSlot &&
      selectedCalendarEvent.timeSlot.display.relatedTs.length > 0
    ) {
      selectedCalendarEvent.timeSlot.display.position = "full";

      state.timeSlots
        .filter((timeSlot) =>
          selectedCalendarEvent.timeSlot.display.relatedTs.includes(timeSlot.id)
        )
        .forEach((relatedTimeSlot) => {
          relatedTimeSlot.display.relatedTs = _.without(
            relatedTimeSlot.display.relatedTs,
            selectedCalendarEvent.timeSlot.id
          );
          if (relatedTimeSlot.display.relatedTs.length === 0) {
            relatedTimeSlot.display.position = "full";
          }
        });

      selectedCalendarEvent.timeSlot.display.relatedTs = [];
    }
  },
  [mutations.UNSET_SELECTED_CALENDAR_EVENT]: (state) => {
    if (state.selectedCalendarEvent) {
      state.selectedCalendarEvent.dynamic = false;
    }

    state.selectedCalendarEvent = null;
  },
  [mutations.SCHEDULE_CALENDAR_EVENT](state, { start, end }) {
    const duration = (end - start) / (1000 * 60);
    let date = dayjs(start);

    let timeSlotDate = date.format("YYYY-MM-DD");
    let timeSlotTime = date.format("HH:mm");

    if (state.selectedCalendarEvent?.timeSlot) {
      if (
        state.items[state.selectedCalendarEvent.timeSlot.eventId].subtype ===
        "night_outside_home"
      ) {
        date = dayjs(start).hour(20).minute(0).second(0).millisecond(0);

        start = date.toDate().getTime();
        end = date.add(duration, "minute").toDate().getTime();

        timeSlotDate = date.format("YYYY-MM-DD");
        timeSlotTime = date.format("HH:mm");
      }

      state.selectedCalendarEvent.timeSlot.date = timeSlotDate;
      state.selectedCalendarEvent.timeSlot.time = timeSlotTime;
      state.selectedCalendarEvent.timeSlot.duration = duration;
    }

    state.selectedCalendarEvent.start = start;
    state.selectedCalendarEvent.end = end;
  },
  [mutations.SET_IMPERSONATION_REDIRECT_PATH]: (state, value) => {
    state.impersonationRedirectPath = value;
  },
};
